import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BsFillFileEarmarkTextFill } from "react-icons/bs";
import { FaMoneyCheckAlt, FaUserCheck, FaUserFriends, FaWpforms } from "react-icons/fa";
import { FcAdvertising } from "react-icons/fc";
import { MdAppRegistration, MdCreateNewFolder, MdDashboard, MdLockPerson, MdOutlinePendingActions, MdOutlineSwitchAccount } from "react-icons/md";
import { RiAdvertisementLine } from "react-icons/ri";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getActiveAdvertisementList, getSingleAdvtDetails, resetCandidateList } from "../../candidatedatamanagement/actions/candidateDataManagementAction";
import label from "../../candidatedatamanagement/labels/candidatedatamanagement_en.json";
import { dashboardCount } from "../../common/actions/commonActions";
import commonLabels from "../../common/labels/common_en.json";
import docLabels from '../../documentsverification/labels/documentlabel.json';
import { getYearList } from "../applicationstages/actions/applicationStagesAction";
import "../styles/main.css";
import Select from "react-select";




// import { FcAdvertising } from "react-icons/fc";


const Dashboard = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(dashboardCount())
    }, [])

    return (
        <div className="dashboard-main">
            <Header />
            <Cards />
        </div>
    )
}

const Header = () => {
    return (
        <div className="header-card">
            <MdDashboard size="2rem" className="text-primary" />
            <div>
                <div className="fw-bold fs-5 text-primary">
                    Dashboard
                </div>
                <div className="fw-bold text-secondary">Dashboard Information</div>
            </div>
        </div>
    )
}

const Cards = () => {
    const { dashboardCount } = useSelector((state) => state.common);
    const navigate = useNavigate(); // ⬅️ Initialize navigate
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [startYear, setStartYear] = useState((new Date()).getFullYear());
    const [advtIdForSearch, setAdvtForSearch] = useState("");
    useEffect(() => {
        dispatch(getYearList())
        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        setAdvtForSearch("");
        dispatch(resetCandidateList());
        // eslint-disable-next-line
    }, [])

    const dispatch = useDispatch();
    const { register, watch, errors, reset, formState } = useForm({
        mode: "onChange"
    });


    const cards = [
        { key: 'allUsers', name: 'All Users', path: "usermanagement", icon: <FaUserFriends style={{ color: '#4682B4' }} /> },
        { key: 'activeUsers', name: 'Active Users', path: "usermanagement", icon: <FaUserCheck style={{ color: '#2E8B57' }} /> },
        { key: 'totalPendingRequests', name: 'Total Pending Requests', icon: <MdCreateNewFolder style={{ color: '#FF8C00' }} /> },
        { key: 'totalPendingDocuments', name: 'Total Pending Documents', icon: <MdOutlinePendingActions style={{ color: '#DAA520' }} /> },
        { key: 'allAdvertisements', name: 'All Advertisements', icon: <RiAdvertisementLine style={{ color: '#2F4F4F' }} /> },
        { key: 'activeAdvertisements', name: 'Active Advertisements', icon: <FcAdvertising style={{ color: '#228B22' }} /> },
        { key: 'pastAdvertisements', name: 'Past Advertisements', icon: <MdOutlineSwitchAccount style={{ color: '#8B0000' }} /> },
        { key: 'totalRegistrations', name: 'Total Registration', icon: <MdAppRegistration style={{ color: '#1E90FF' }} /> },
        { key: 'lockedProfiles', name: 'Total Locked Profile', icon: <MdLockPerson style={{ color: '#DC143C' }} /> },
    ]


    // const handleCardClick = (key) => {
    //     switch (key) {
    //         case "allUsers":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Your component for All Users
    //             break;
    //         case "activeUsers":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Your component for Active Users
    //             break;
    //         case "totalPendingRequests":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Component for Pending Requests
    //             break;
    //         case "totalPendingDocuments":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Component for Pending Documents
    //             break;
    //         case "allAdvertisements":
    //             setSelectedComponent(<ActiveAdvertisement />); // ✅ Component for All Advertisements
    //             break;
    //         case "activeAdvertisements":
    //             setSelectedComponent(<ActiveAdvertisement />); // ✅ Same component for Active Advertisements (or you can create a new one)
    //             break;
    //         case "pastAdvertisements":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Component for Past Advertisements
    //             break;
    //         case "totalRegistrations":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Component for Total Registrations
    //             break;
    //         case "lockedProfiles":
    //             setSelectedComponent(<ActiveUserTable />); // ✅ Component for Locked Profiles
    //             break;
    //         default:
    //             setSelectedComponent(null);
    //     }
    // };

    const { yearList } = useSelector(
        (state) => state.documentVerificationReducer,
        shallowEqual
    );

    const { activeAdvertisementList, candidateList, singleAdvtDetails } = useSelector((state) => state.candidateDataManagementReducer, shallowEqual)

    const handleYearChange = (value) => {
        setStartYear(value);
        dispatch(getActiveAdvertisementList(value));
        setAdvtForSearch("");
        dispatch(resetCandidateList());
    };

    const handleDropdownSeachAdvt = (e) => {
        setAdvtForSearch(e.target.value);
        dispatch(resetCandidateList());
    };

    const resetAction = (e) => {
        setAdvtForSearch("")
        reset();
        activeAdvertisementList.length = 0;
        dispatch(resetCandidateList());
        setStartYear((new Date()).getFullYear());
        if (yearList && yearList.length > 0) {
            let year = yearList[0];
            setStartYear(year);
            dispatch(getActiveAdvertisementList(year));
        }
    };

    const searchAction = () => {
        let requestBody = {}
        requestBody.advertisementId = advtIdForSearch;
        dispatch(getSingleAdvtDetails(requestBody))
    };

    useEffect(() => {
        if (yearList && yearList.length > 0) {
            let year = yearList[0];
            setStartYear(year);
            dispatch(getActiveAdvertisementList(year));
        }
        //   advtIdForSearch &&  searchAction()
        advtIdForSearch && searchAction()
    }, [yearList, advtIdForSearch]);

    return (
        <div>
            <div className="d-flex gap-4 flex-wrap p-4">
                {dashboardCount && Object.entries(dashboardCount).map(([key, value], i) => {
                    const matchedCard = cards.find(({ key: cardKey }) => cardKey === key);
                    const { icon, name, path } = matchedCard;
                    {/* if (!matchedCard || key === 'totalPendingRequests' || key === 'totalPendingDocuments') {
                    return null;
                } */}
                    return (
                        <div
                            className="dashboard-cards"
                            key={i}
                            onClick={() => path && navigate(`/oasadmin/${path}`)} // Corrected template literal usage
                            style={{ cursor: path ? 'pointer' : 'default' }} // ⬅️ Add pointer cursor if clickable
                        >   <div>
                                <div className="fs-6 fw-bold text-primary text-nowrap">{name}</div>
                                <div className="fs-2 fw-bold">{value}</div>
                            </div>
                            <div className="icon">
                                {icon}
                            </div>
                        </div>
                    )
                })}
                {/* Show the selected component below the cards */}
                {/* {selectedComponent && (
                <div className="mt-4">
                    {selectedComponent}
                </div>
            )} */}

            </div>
            {/* Horizontal line to seperate  */}
            <hr />
            <div>
                <form id="searchForm">
                    <div className="row ms-2">
                        <div className='col-md-2'>
                            <label className="fw-bold  float-start">{docLabels.SELECT_YEAR}</label>
                            <select
                                className="form-select"
                                name="selectedYear"
                                value={startYear}
                                onChange={(e) => {
                                    handleYearChange(e.target.value)
                                }}
                            >
                                {yearList &&
                                    yearList.length > 0 &&
                                    yearList
                                        .map((element, i) => (
                                            <option key={i} >{element}</option>
                                        ))}
                            </select>
                        </div>

                        <div className="col-md-6">
                            <label className="fw-bold ">
                                {label.SELECT_ADVT}&nbsp;
                                <span className="redColor">*</span>
                            </label>
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                name="search_using"
                                value={activeAdvertisementList
                                    .map(ele => ({
                                        value: ele.id,
                                        label: `${ele.advertisementNo}/${ele.year} - ${ele.name}`,
                                    }))
                                    .find(option => option.value === advtIdForSearch) || null}
                                onChange={(selectedOption) => handleDropdownSeachAdvt({ target: { name: "search_using", value: selectedOption?.id } })}
                                options={activeAdvertisementList.map((ele) => ({
                                    value: ele.id,
                                    label: `${ele.advertisementNo}/${ele.year} - ${ele.name}`,
                                    id: ele.id,
                                }))}
                                placeholder={commonLabels.COMBO_SELECT}
                                isSearchable
                            />
                        </div>
                        {/* <div className={`col-md-6 col-lg-2 mt17 mt-2'}`}>
                            <div className="row">
                                <div className="col-md-6 mt-2 ">
                                    <button type="button" disabled={(!(formState.isValid && advtIdForSearch))} className=" btn btn-primary custom_button  btn-sm" onClick={(e) => { searchAction() }}>
                                        {label.SEARCH}
                                    </button>
                                </div>
                                <div className="col-md-6 mt-2 ms-n4">
                                    <button type="button" onClick={resetAction} className="btn btn-outline-secondary btn-sm ms-3">
                                        {label.RESET}
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </form>
                {advtIdForSearch && <div className="d-flex gap-4 flex-wrap p-4 mt-4">
                    {(singleAdvtDetails.totalApplications >= 0) && <div
                        className="dashboard-cards"
                    >
                        <div className="">
                            <div className="fs-6 fw-bold text-primary text-nowrap"> Total Application </div>
                            <div className="fs-2 fw-bold">{singleAdvtDetails.totalApplications}</div>
                        </div>
                        <div className="icon pl-5">
                            <FaWpforms size={30} color="#4682B4" />
                        </div>
                    </div>}
                    {(singleAdvtDetails.applicationsFilled >= 0) && <div className="dashboard-cards">
                        <div>
                            <div className="fs-6 fw-bold text-primary text-nowrap">Application Filled</div>
                            <div className="fs-2 fw-bold">{singleAdvtDetails.applicationsFilled}</div>
                        </div>
                        <div className="icon">
                            <BsFillFileEarmarkTextFill size={30} color="#2E8B57" />
                        </div>
                    </div>}
                    {(singleAdvtDetails.applicationsPaid >= 0) && <div className="dashboard-cards " >
                        <div>
                            <div className="fs-6 fw-bold text-primary text-nowrap">Application Paid</div>
                            <div className="fs-2 fw-bold">{singleAdvtDetails.applicationsPaid}</div>
                        </div>
                        <div className="icon">
                            <FaMoneyCheckAlt size={30} color="#DAA520" />
                        </div>
                    </div>}
                </div>}
            </div>
        </div >
    )
}

export default Dashboard;